import BillOfMaterial from "../screens/ingredients/BillOfMaterial";
import IngredientList from "../screens/ingredients/ingredientList/IngredientList";
import { adminAccess, supplierAccess, userAccess } from "./useRoleAccess";
import { DISABLE_BOM_CHEMICAL } from "../config/constants"; 


export const IngredientRoutes = [
  {
    path: "/ingredient",
    route: DISABLE_BOM_CHEMICAL ? <IngredientList /> : <BillOfMaterial />,
    protectRoutes: true,
    roleGrantAccess: [...adminAccess, ...userAccess, ...supplierAccess]
  }
];
